/** Words the carrier acts on before a workflow ever sees the reply: CallRail's approved opt-out
 *  set (see smsOptOut.ts) plus STOPALL, the opt-in words START and UNSTOP, and HELP, which gets the
 *  carrier's own help response. YES is here because a "Yes" reply was handled as an opt-in
 *  (TRK-5907), so it can never mean "confirmed". */
export const CARRIER_KEYWORDS: readonly string[] = [
  `STOP`,
  `STOPALL`,
  `CANCEL`,
  `UNSUBSCRIBE`,
  `QUIT`,
  `END`,
  `START`,
  `UNSTOP`,
  `YES`,
  `HELP`,
]

/** Wait for a keyword's exits after its reply options, named with the engine's own words. */
export const FIXED_REPLY_EXITS = [`other_reply`, `no_reply`] as const

/** The keyword field's text → the stored list: split on commas and whitespace, upper-cased,
 *  trailing punctuation dropped (the engine drops it from replies, so `C.` could never match),
 *  first occurrence kept. */
export function parseKeywords(text: string): string[] {
  const words = text
    .split(/[\s,]+/)
    .map((word) =>
      word
        .trim()
        .toUpperCase()
        .replace(/[^\p{L}\p{N}]+$/u, ``),
    )
    .filter(Boolean)
  return [...new Set(words)]
}
